<script setup>
import { computed } from 'vue';
import { useMessageContext } from '../../provider.js';

import MessageFormatter from 'shared/helpers/MessageFormatter.js';
import { MESSAGE_VARIANTS } from '../../constants';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
});

const { variant } = useMessageContext();

const formattedContent = computed(() => {
  // #region agent log
  fetch('http://127.0.0.1:7243/ingest/31ae3a12-168f-4235-98e5-956c21b4b1cb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'FormattedContent.vue:17',message:'formattedContent computed',data:{contentLength:props.content?.length,contentPreview:props.content?.substring(0,50),variant:variant.value},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
  // #endregion
  
  if (variant.value === MESSAGE_VARIANTS.ACTIVITY) {
    return props.content;
  }

  let result;
  try {
    const formatter = new MessageFormatter(props.content);
    result = formatter.formattedMessage;
    // #region agent log
    fetch('http://127.0.0.1:7243/ingest/31ae3a12-168f-4235-98e5-956c21b4b1cb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'FormattedContent.vue:25',message:'MessageFormatter result',data:{resultLength:result?.length,resultPreview:result?.substring(0,100),isEmpty:!result||result.length===0},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
    // #endregion
  } catch (error) {
    // #region agent log
    fetch('http://127.0.0.1:7243/ingest/31ae3a12-168f-4235-98e5-956c21b4b1cb',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'FormattedContent.vue:28',message:'MessageFormatter error',data:{error:error.message,stack:error.stack},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'C'})}).catch(()=>{});
    // #endregion
    throw error;
  }
  
  return result;
});
</script>

<template>
  <span v-dompurify-html="formattedContent" class="prose prose-bubble" />
</template>
